// 定义支持的语言类型
type Language = 'en' | 'zh' | 'ru';

// 定义语言资源接口
export interface LanguageResources {
  gameTitle: string;
  startGame: string;
  settings: string;
  collect: string;
  goal: string;
  xmas: string;
  score: string;
  level: string;
  sound: string;
  music: string;
  back: string;
  play: string;
  pause: string;
  gameOver: string;
  congratulations: string;

  shuffle: string;
  shuffletip: string;
  remove: string;
  removetip: string;
  remain: string;
  nextlevel: string;
  restart: string;
  use: string;
  revive: string;
  revivetip: string;
  playtimes: string;
  moveleft: string;
  moveright: string;
  guide_match: string;
  guide_block: string;
  // 可以继续添加更多翻译键
}

// 定义所有语言资源
const resources: Record<Language, LanguageResources> = {
  en: {
    gameTitle: "Adventure Quest",
    startGame: "Start Game",
    collect: "Collect\nMode",
    goal: "Level Goal",
    xmas: "Christmas\nMode",
    settings: "Settings",
    score: "Score",
    level: "Level",
    sound: "Sound",
    music: "Music",
    back: "Back",
    play: "Play",
    pause: "Pause",
    gameOver: "Game Over",
    congratulations: "Congratulations!",
    shuffle: "Shuffle",
    shuffletip: "Rearrange the position of the jewels",
    remove: "Remove",
    removetip: "Remove a couple of jewels",
    remain: "Remain",
    nextlevel: "Next Level",
    restart: "Restart",
    use: "Use",
    revive: "Revive",
    revivetip: "Pick out some jewels and revive",
    playtimes: "Level played: XXX times​",
    moveleft: "Jewels will move left",
    moveright: "Jewels will move right",
    guide_match: "Great!\nThe same jewels will match in the passage\nand earn points!",
    guide_block: "Different jewels can block the passage\nMore than XXX will result in game failure!",
  },
  zh: {
    gameTitle: "冒险之旅",
    startGame: "开始游戏",
    settings: "设置",
    collect: "收集模式",
    goal: "关卡目标",
    xmas: "圣诞模式",
    score: "分数",
    level: "关卡",
    sound: "音效",
    music: "音乐",
    back: "返回",
    play: "播放",
    pause: "暂停",
    gameOver: "游戏结束",
    congratulations: "恭喜！",
    shuffle: "打乱",
    shuffletip: "将所有宝石位置打乱",
    remove: "移除",
    removetip: "移除一组的宝石",
    remain: "剩余",
    nextlevel: "下一关",
    restart: "重新开始",
    use: "使用",
    revive: "复活",
    revivetip: "拿出若干宝石然后复活",
    playtimes: "本关已挑战了XXX次！",
    moveleft: "宝石将向左移动",
    moveright: "宝石将向右移动",
    guide_match: "太棒了！\n同样的宝石会在通道中匹配\n并获得分数！",
    guide_block: "不同的宝石会阻塞通道\n超过XXX个导致游戏失败！",
  },
  ru: {
    gameTitle: "Приключенческий Квест",
    startGame: "Начать Игру",
    collect: "Режим\nСбора",
    goal: "Цель Уровня",
    xmas: "Рождественский\nРежим",
    settings: "Настройки",
    score: "Счёт",
    level: "Уровень",
    sound: "Звук",
    music: "Музыка",
    back: "Назад",
    play: "Играть",
    pause: "Пауза",
    gameOver: "Конец Игры",
    congratulations: "Поздравляем!",
    shuffle: "Перемешать",
    shuffletip: "Переставить местами драгоценности",
    remove: "Удалить",
    removetip: "Удалить несколько драгоценностей",
    remain: "Осталось",
    nextlevel: "Следующий Уровень",
    restart: "Начать Заново",
    use: "Использовать",
    revive: "Возродиться",
    revivetip: "Выберите несколько драгоценностей для возрождения",
    playtimes: "Уровень пройден: XXX раз(а)",
    moveleft: "Драгоценности сдвинутся влево",
    moveright: "Драгоценности сдвинутся вправо",
    guide_match: "Отлично!\nОдинаковые драгоценности будут совпадать в проходе\nи приносить очки!",
    guide_block: "Разные драгоценности могут блокировать проход\nБолее XXX приведут к поражению!",
  },
};

// 语言服务类
export class LanguageService {
  private currentLanguage: Language;
  public static instance: LanguageService;

  public constructor(defaultLanguage: Language = 'en') {
    this.currentLanguage = defaultLanguage;
    LanguageService.instance = this;
  }

  // 设置当前语言
  public setLanguage(language: Language): void {
    if (resources[language]) {
      this.currentLanguage = language;
      // 在实际应用中，这里可以触发语言变更事件
      console.log(`Language changed to: ${language}`);
    } else {
      console.warn(`Language ${language} is not supported.`);
    }
  }

  // 获取当前语言
  public getCurrentLanguage(): Language {
    return this.currentLanguage;
  }

  // 获取翻译
  public translate<T extends keyof LanguageResources>(key: T): string {
    return resources[this.currentLanguage][key] || resources['en'][key] || String(key);
  }

  // 获取所有支持的语言
  public getSupportedLanguages(): Language[] {
    return Object.keys(resources) as Language[];
  }
}